/* Shopify's Cart Ajax API accepts an empty discount value to clear manual
   discount codes. Keep this small and independent so it works in both the
   custom cart drawer and Dawn's direct /cart route. */
(function () {
  if (window.__fizzyCartDiscountRemoval) return;
  window.__fizzyCartDiscountRemoval = true;

  function status(button, message) {
    var label = button.querySelector('[data-fizzy-discount-label]');
    if (label) label.textContent = message;
    else button.textContent = message;
  }

  function refreshCart() {
    if (window.FizzyCart && typeof window.FizzyCart.refresh === 'function') {
      return window.FizzyCart.refresh();
    }
    window.location.reload();
    return Promise.resolve();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-fizzy-remove-discounts]');
    if (!button || button.disabled) return;

    event.preventDefault();
    var url = button.getAttribute('data-fizzy-cart-update-url') || '/cart/update.js';
    var original = button.textContent.trim();
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status(button, 'Removing…');

    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: '' })
    }).then(function (response) {
      if (!response.ok) throw new Error('The discount could not be removed.');
      return response.json();
    }).then(function () {
      return refreshCart();
    }).catch(function () {
      status(button, 'Try again');
      button.disabled = false;
      button.removeAttribute('aria-busy');
      window.setTimeout(function () {
        if (!button.disabled) status(button, original);
      }, 2500);
    });
  });
})();

/* Follow the visible viewport while the on-screen keyboard is open.
   Keep pinch zoom available; this only adjusts the focused cart form. */
(function () {
  if (window.__fizzyCartKeyboard) return;
  window.__fizzyCartKeyboard = true;
  var viewport = window.visualViewport;
  var frame = 0;
  function sync() {
    frame = 0;
    var drawer = document.getElementById('fizzyCartDrawer');
    if (!drawer) return;
    var input = document.activeElement;
    var editing = drawer.classList.contains('open') && input &&
      input.matches('[data-disc-input]') && window.matchMedia('(max-width: 820px)').matches;
    drawer.classList.toggle('fcd-editing-discount', !!editing);
    if (!editing) {
      drawer.style.removeProperty('--fcd-visible-height');
      drawer.style.removeProperty('--fcd-visible-top');
      return;
    }
    if (viewport && viewport.scale > 1.05) return;
    drawer.style.setProperty('--fcd-visible-height', (viewport ? viewport.height : window.innerHeight) + 'px');
    drawer.style.setProperty('--fcd-visible-top', (viewport ? viewport.offsetTop : 0) + 'px');
    input.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
  }
  function schedule() { if (!frame) frame = window.requestAnimationFrame(sync); }
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  window.addEventListener('resize', schedule);
  if (viewport) {
    viewport.addEventListener('resize', schedule);
    viewport.addEventListener('scroll', schedule);
  }
})();
